import {getNameById, getIdByName, getRecordById, getRecordByName, getIndexById} from '@/utils/public.js'
export default {
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    //
    getNameById(id, arr) {
      return getNameById(id, arr)
    },
    getIdByName(name, arr) {
      return getIdByName(name, arr)
    },
    getRecordById(id, arr) {
      return getRecordById(id, arr)
    },
    getRecordByName(name, arr) {
      return getRecordByName(name, arr)
    },
    getIndexById(id, arr) {
      return getIndexById(id, arr)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/id-name-mixin.js